import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';

export default function Home() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [isError, setIsError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const token = searchParams.get('token') || '';
    
    useEffect(() => {
        if (token) {
            axios.get('/BBAuthentication/LoginWithToken', {
                params: {  token: token || '' }
            })
                .then(response => {
                    const data = response.data;
                    if (data.RedirectPage) {
                        navigate(data.RedirectPage, data.ErrorMessage ? { state: { ErrorMessage: data.ErrorMessage } } : undefined);
                    } else if (data.IsAuthenticated) {
                        window.location.replace(data.ReturnUrl);                         
                    } else if (data.ErrorMessage) {
                        setIsError(true)
                        setErrorMessage(data.ErrorMessage)
                    }
                })
                .catch(error => {
                    console.error('Error:', error);
                    navigate('/login');
                });
        } else {
            navigate('/login');
        }
    }, []);

    return (
        <>
            {isError && (
                <div className="register-inner">
                    <div className="registerbody-inner">
                        <div className="login-form" style={{ textAlign: 'center', alignItems: 'center' }}>
                            {errorMessage && <h4 className="text-red-500 font-bold">{errorMessage}</h4>}
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}
